import api from '@utils/api';

export const getConsumptionReport = async (params) => {
  try {
    // Asumiendo que los parámetros son start_date, end_date, y location
    const response = await api.get('/consumption/report', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching consumption report:', error);
    throw error;
  }
};
